import React from 'react';
import PlayerCard from './PlayerCard';
import { GameState, Player } from '../../types';
import { PANEL_STYLES, HEADING_STYLES } from '../../constants/styles';
import { getPlayerLastBid } from '../../utils/playerUtils';

interface PlayersListProps {
  gameState: GameState;
  myPlayerId: string | null;
  isPlaying: boolean;
  isWaiting: boolean;
}

const PlayersList: React.FC<PlayersListProps> = ({
  gameState,
  myPlayerId,
  isPlaying,
  isWaiting,
}) => {
  // Rotate players so the round's opening bidder is shown first (leftmost)
  // Apply rotation during playing and revealing phases (not in waiting/lobby)
  const orderedPlayers = !isWaiting && gameState.roundStartPlayerIndex >= 0
    ? [
        ...gameState.players.slice(gameState.roundStartPlayerIndex),
        ...gameState.players.slice(0, gameState.roundStartPlayerIndex)
      ]
    : gameState.players;

  return (
    <div className={PANEL_STYLES}>
      <h2 className={`${HEADING_STYLES} mb-1`}>Players</h2>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {orderedPlayers.map((player: Player) => {
          const originalIndex = gameState.players.findIndex(p => p.id === player.id);
          const lastBid = getPlayerLastBid(player.id, gameState.bidHistory || []);

          return (
            <PlayerCard
              key={player.id}
              player={player}
              isCurrentPlayer={gameState.currentPlayerIndex === originalIndex}
              isSelf={player.id === myPlayerId}
              isPlaying={isPlaying}
              isWaiting={isWaiting}
              lastBid={lastBid}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PlayersList;